<template>
    <div class="load-mor-sec">


        <div v-for="(item , index) in searchResult">

            <!--            {{item.image_url}}-->
            <!--            <br>-->
            <!--            {{item.url}}-->
            <!--            <br>-->
            <!--            {{item.name}}-->
            <!--            <br>-->
            <!--            {{item.short_intro_text}}-->


            <a :href="item.url" class="search-item__link ">
                <div class="media">
                    <div class="search-item__image mr-3">

                        <div class="placeholder80x80"
                             v-bind:style="{ backgroundImage: `url('${item.image_url }')`}">
                        </div>
                    </div>
                    <div class="media-body">
                        <div class="search-item__title"> {{item.name}}</div>
                        <div class="search-item__desc"> {{item.short_intro_text}}...</div>
                    </div>
                </div>
            </a>
            <hr>
        </div>
        <div v-if="isLoading" class="loader-overlay d-flex justify-content-center align-items-center">
            <div class="loader-overlay-inner">
                <div class="loader"></div>
            </div>
        </div>
        <button v-if="has_more" v-on:click="loadMorSearchResults" class="btn btn-lg btn-coffee">Još rezultata</button>
    </div>
</template>

<script>
    export default {
        name: "searchLoadMoreComponent",
        data() {
            return {

                search: '',
                last_product: '',
                last_blog: '',
                searchResult: [],
                has_more: true,
                isLoading: false,
            }
        },
        mounted() {

            this.search = window.searchTermFromBlade;
            this.last_product = window.first_page_last_product;
            this.last_blog = window.first_page_last_blog;
        },
        methods: {
            loadMorSearchResults() {

                const vm = this;
                vm.isLoading = true;
                const getParams = {
                    search: this.search,
                    last_product: this.last_product,
                    last_blog: this.last_blog,
                };
                axios.get(APP_URL + '/api/search', {
                    params: getParams
                }).then(function (response) {

                    // console.log("response: ", response.data);
                    // console.log("vm.searchResult: ", vm.searchResult);
                    // console.log("response.data.data: ", response.data.data);
                    vm.searchResult.push(...response.data.data);
                    vm.last_product = response.data.last_product;
                    vm.last_blog = response.data.last_blog;
                    vm.has_more = response.data.has_more;
                    vm.isLoading = false;

console.log(" vm.has_more: ",  vm.has_more);
                }).catch(function (error) {
                    console.log(error);
                    // vm.isLoading = false;
                });

            },
        }
    }
</script>

<style scoped>
    .load-mor-sec {
        position: relative;
    }

    .loader-overlay {
        padding: 30px;
        position: relative;

    }

    .loader {
        border: 16px solid #f3f3f3;
        border-radius: 50%;
        border-top: 16px solid #e52e28;
        width: 120px;
        height: 120px;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }

    /* Safari */
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }
        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/components/searchLoadMoreComponent.vue